import type { Handle } from 'remix/ui'
import { BackupDropOverlay } from './components/backup-drop-overlay'
import { lazyPage } from './components/lazy-page'
import { Router } from './router'
import { HomePage } from './pages/home-page'

const ProjectRoute = lazyPage(() => import('./pages/project-route'), 'ProjectRoute')
const SettingsPage = lazyPage(() => import('./pages/settings-page'), 'SettingsPage')

export function App(_handle: Handle) {
  return () => (
    <div className="app-shell">
      <Router
        routes={{
          '/': () => <HomePage />,
          '/project/:projectId': (params) => (
            <ProjectRoute projectId={params.projectId ?? ''} />
          ),
          '/settings': () => <SettingsPage />,
        }}
      />
      <BackupDropOverlay />
    </div>
  )
}
